// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs_tabsContainer__U33fl","titlesContainer":"Tabs_titlesContainer__igq6k","amountInDropdown":"Tabs_amountInDropdown__qa9TR"};